export default "__VITE_ASSET__BdZzzcTd__"